import React from "react";
import { Button, Box, Typography } from "@mui/material";

const DeleteConfirmation = ({ onConfirm, onCancel, nameUser }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        width: "300px",
        textAlign: "center",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
      }}
    >
      {/* العبارة التأكيدية */}
      <Typography variant="h6" sx={{ mb: 2, color: "#333" }}>
        هل أنت متأكد من حذف الإعلان؟
      </Typography>

      {/* الأزرار */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#4CAF50", color: "#fff" }}
          onClick={onCancel}
          autoFocus
        >
          لا
        </Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: "error", color: "#fff" }}
          onClick={onConfirm}
        >
          نعم
        </Button>
      </Box>
    </Box>
  );
};

export default DeleteConfirmation;
